import withSharedStyles from "../theme/Shared.style";

// Breadcrumbs: 13px muted, current page in ink 600. Catalog pages only.
const withCustomStyles = withSharedStyles(theme => {
  const { color, fontSize } = theme.tokens;
  return {
    root: {
      fontSize: fontSize.small,
      color: color.muted,
      "& .MuiBreadcrumbs-separator": { margin: "0 8px", color: color.muted },
      "& .MuiBreadcrumbs-ol": { rowGap: 4 }
    },
    link: {
      cursor: "pointer",
      "&:hover": { color: `${color.ink} !important` }
    },
    breadcrumbText: {
      color: `${color.muted} !important`,
      fontSize: fontSize.small,
      fontWeight: 400,
      textDecoration: "none",
      display: "inline !important"
    },
    nonClickable: {
      color: `${color.ink} !important`,
      fontWeight: 600,
      textDecoration: "none !important",
      fontSize: fontSize.small,
      cursor: "default"
    }
  };
});

export default withCustomStyles;
